module.exports = __webpack_public_path__ + "img/logo7.d516d9e4.png";